import Tickets from "@components/Accesses/AccessDetails/screens/Tickets";

export default Tickets;
